import memoizee from 'memoizee';

/**
 *
 * readme:
 *      https://medium.com/angular-in-depth/how-to-improve-angular-performance-by-just-adding-just-8-characters-877bde708ddd
 *      https://github.com/medikoo/memoizee#readme
 *
 * template:
 * ---------------
 *  <h1>{{getTitle(getNumber)}}</h1>
 *
 *
 * code:
 * ---------------
 * @Memoizee({})
 getTitle(framework: string) {
        console.log('getTitle is called ' + Math.random());
        return `I love ${framework.toUpperCase()} + ${Math.random()}`;
    }

 get getNumber(): string {
        // since same value, memo caching works
        return 'FooBar';

        // if diff value, memo cache will not kick in
        // return String(Math.random()); // force non caching as new value every time
    }
 */


export function Memoizee(config) {
    // tslint:disable-next-line
    return function(target, key, descriptor) {
        const oldFunction = descriptor.value;
        const newFunction = memoizee(oldFunction, config);
        descriptor.value = function() {
            return newFunction.apply(this, arguments);
        };
    };
}
